import { Pipe, PipeTransform } from '@angular/core';
import { isSellerOfGrassiGroup } from '@shared-logic/subjects';
import { OrderString } from '../../interfaces/order.interface';
import { filterOrderWithOrderString } from './filter.by.order.pipe';
import { isFromCommodities } from './filterByBuyerType.pipe';
import { filterOrderByStrings } from './filterWithString.pipe';
import { isPriceToFix } from './filter-by-condition-type.pipe';
import { isOrderVisibleForCommodities } from './filterWithOutContractStatus.pipe';
import { Order } from '@shared-logic/orders';


@Pipe({
  name: 'filterAllOrder'
})
export class FilterAllOrderPipe implements PipeTransform {

  transform(list: any[], isComercial: boolean, order: OrderString, search: string, identificator: string, conditionType: string, showContracts: boolean, conditionsFilters: number[]) {
    let arrayFinal: any[] = [];

    const searchs = search.trim().toLowerCase().split(" ");

    list.forEach(element => {
      if (isOwnerGrassiGroupOrder(element, isComercial) &&
        filterOrderByStrings(element, searchs) &&
        isOrderVisibleForCommodities(element, isComercial, showContracts) &&
        filterOrderWithOrderString(element, order) &&
        isFromCommodities(element.price, identificator) &&
        isPriceToFix(element.price, conditionType, conditionsFilters)) {
        arrayFinal.push(element);
      }
    })

    return arrayFinal;
  }
}

//Si el usuario es comercial, no debe poder ver los negocios donde el vendedor sea del grupo Grassi.
//Si no es comercial (es operador), retorna true (puede ver todo).
export function isOwnerGrassiGroupOrder(order: Order, isComercial: boolean) {
  if (!isComercial) return true;
  return !isSellerOfGrassiGroup(order.sellerData.codeS);
}